import saveAs from 'file-saver';
import { convertCanvasToTiff } from '../../../../../utils/canvasToTiff';
import renderFramingChart from './renderFramingChart';
import { FramingChartProps } from './types';

type ImageType = 'png' | 'tiff';

const getFilename = (
  props: FramingChartProps,
  imageType: ImageType
) =>
  `${props.canvasResolution.width}x${props.canvasResolution.height}_${props.lensSqueezeFactor}x_FramingChart.${imageType}`;

const prepareFramingChart = async (props: FramingChartProps) => {
  const tempCanvas = document.createElement('canvas');
  await renderFramingChart(tempCanvas, props);
  return tempCanvas;
};

export async function downloadFramingChartImage(
  type: ImageType,
  props: FramingChartProps
): Promise<void> {
  try {
    const tempCanvas = await prepareFramingChart(props);
    const filename = getFilename(props, type);

    if (type === 'png') {
      tempCanvas.toBlob((blob) => {
        if (blob) {
          saveAs(blob, filename);
        } else {
          console.error('Failed to generate PNG blob');
        }
      }, 'image/png');
    } else {
      const tiffBlob = await convertCanvasToTiff(tempCanvas);
      saveAs(tiffBlob, filename);
    }
  } catch (error) {
    console.error(
      `Failed to download ${type.toUpperCase()} file:`,
      error
    );
  }
}
